import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Contenedor que mantiene un bloque Elife de la página de producto al día con la variante
 * seleccionada. Mismo patrón que product-inventory / product-price de Horizon: escucha
 * ProductSelectEvent en la sección, espera el HTML nuevo que trae el evento y copia el
 * contenido de su gemelo `elife-variant-sync[data-sync-id]`.
 *
 * Markup: <elife-variant-sync data-sync-id="{{ block.id }}" data-product-id="{{ product.id }}">…</elife-variant-sync>
 *
 * @extends {Component}
 */
class ElifeVariantSync extends Component {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section = null;
  }

  /**
   * @param {Event & { promise?: Promise<any> }} event - ProductSelectEvent de @shopify/events
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    if (!event.promise) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const twin = html.querySelector(`elife-variant-sync[data-sync-id="${CSS.escape(this.dataset.syncId ?? '')}"]`);
        if (!twin) return;

        morph(this, twin, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[elife-variant-sync] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('elife-variant-sync')) {
  customElements.define('elife-variant-sync', ElifeVariantSync);
}
